/** Web Gmail compose URL — works on PC browsers without a desktop mail client. */
export function gmailComposeUrl(
  email: string,
  options?: { subject?: string; body?: string },
): string {
  const to = email.trim();
  const params = ['view=cm', 'fs=1', `to=${encodeURIComponent(to)}`];
  const subject = options?.subject?.trim();
  const body = options?.body?.trim();
  if (subject) {
    params.push(`su=${encodeURIComponent(subject)}`);
  }
  if (body) {
    params.push(`body=${encodeURIComponent(body)}`);
  }
  return `https://mail.google.com/mail/u/0/?${params.join('&')}`;
}

export function mailtoUrl(email: string, options?: { subject?: string; body?: string }): string {
  const to = email.trim();
  const params = new URLSearchParams();
  const subject = options?.subject?.trim();
  const body = options?.body?.trim();
  if (subject) {
    params.set('subject', subject);
  }
  if (body) {
    params.set('body', body);
  }
  const query = params.toString();
  return query ? `mailto:${to}?${query}` : `mailto:${to}`;
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  const value = text.trim();
  if (!value) {
    return false;
  }
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* fall through */
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
